import * as React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'

import { VoiceList } from 'features/Voices/VoiceList'

export class VoicesPage extends React.Component {
  render() {
    return (
      <Page layout={{ header: 'app' }} title="Actor Recordings">
        <PageHeader>
          <Crumbs title="Actor Recordings" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          <VoiceList page={1} />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Voices/Voices.tsx